import { createContext } from 'react';

import { type ToastMessage, type ToastProps } from './Toast.js';

export interface Context {
  open: (
    message: string | ToastMessage,
    options?: Partial<Omit<ToastProps, 'onClose' | 'message'>>
  ) => void;
  showSuccess: (message: string | ToastMessage) => void;
  showError: (message: string | ToastMessage) => void;
  showWarning: (message: string | ToastMessage) => void;
  showInfo: (message: string | ToastMessage) => void;
}

export const ToastContext = createContext<Context>({} as Context);
